import { gql } from '@apollo/client';

const GetInitialUserSetting = gql`
    query GetUserSettings {
        getUserSettings {
            id
            theme
            allow_notifications
            show_notifications
        }
    }
`;

export { GetInitialUserSetting };
